import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';

interface ExpandableProps {
  children: React.ReactNode;
  expanded?: boolean;
  triggerChange?: boolean;
  $paddingTop?: string;
}

const ExpandableContent: React.FC<ExpandableProps> = ({ children, triggerChange, expanded = false, $paddingTop }) => {
  const [height, setHeight] = useState<string>(expanded ? '100%' : '0');
  const contentRef = useRef<HTMLDivElement>(null);

  const updateHeight = useCallback(() => {
    setHeight(expanded && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0');
  }, [expanded]);

  useEffect(() => {
    updateHeight();

    if (contentRef.current) {
      const resizeObserver = new ResizeObserver(updateHeight);
      resizeObserver.observe(contentRef.current);

      return () => resizeObserver.disconnect();
    }

    return () => null;
  }, [updateHeight, triggerChange, expanded]);

  return (
    <Container $height={height}>
      <Content ref={contentRef} $paddingTop={$paddingTop}>
        {children}
      </Content>
    </Container>
  );
};

export default ExpandableContent;

const Container = styled.div<{ $height: string }>`
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  height: ${({ $height }) => $height};
`;

const Content = styled.div<{ $paddingTop?: string }>`
  padding-top: ${({ $paddingTop }) => $paddingTop ?? '0px'};
`;
